export default __webpack_public_path__ + "da430102826a2a4e454c839d7749ed7a.jpg";